
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'
import * as core from '../core'
import * as exposed from '../exposed'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line
import {Request} from '../core/Request';
import {FieldModelRequest} from '../core/Request';
import {SymbolDayProfitLossMultipleInfoSubscribeResponse} from './SymbolDayProfitLossMultipleInfoSubscribeResponse';

/**
 * SymbolDayProfitLossMultipleInfoSubscribeRequest struct
 */
class SymbolDayProfitLossMultipleInfoSubscribeRequest extends Request {
  /**
   * Initialize struct
   * @param {!Request=} parent
   * @param {!Set=} symbols
   * @constructor
   */
  constructor (parent = new Request(), symbols = new Set()) {
    super()
    super.copy(parent)
    this.Symbols = symbols
  }

  /**
   * Copy struct (shallow copy)
   * @this {!SymbolDayProfitLossMultipleInfoSubscribeRequest}
   * @param {!SymbolDayProfitLossMultipleInfoSubscribeRequest} other Other struct
   * @returns {!SymbolDayProfitLossMultipleInfoSubscribeRequest} This struct
   */
  copy (other) {
    super.copy(other)
    if (other.Symbols != null) {
      this.Symbols = new Set()
      for (let item of other.Symbols) {
        if (item != null) {
          let tempItem
          tempItem = item
          this.Symbols.add(tempItem)
        } else {
          this.Symbols.add(null)
        }
      }
    } else {
      this.Symbols = null
    }
    return this
  }

  /**
   * Clone struct (deep clone)
   * @this {!SymbolDayProfitLossMultipleInfoSubscribeRequest}
   * @returns {!SymbolDayProfitLossMultipleInfoSubscribeRequest} Cloned struct
   */
  clone () {
    // Serialize the struct to the FBE stream
    let writer = new SymbolDayProfitLossMultipleInfoSubscribeRequestModel(new fbe.WriteBuffer())
    writer.serialize(this)

    // Deserialize the struct from the FBE stream
    let reader = new SymbolDayProfitLossMultipleInfoSubscribeRequestModel(new fbe.ReadBuffer())
    reader.attachBuffer(writer.buffer)
    return reader.deserialize().value
  }

  /**
   * Is this struct equal to other one?
   * @this {!SymbolDayProfitLossMultipleInfoSubscribeRequest}
   * @param {!SymbolDayProfitLossMultipleInfoSubscribeRequest} other Other struct
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof SymbolDayProfitLossMultipleInfoSubscribeRequest)) {
      throw new TypeError('Instance of SymbolDayProfitLossMultipleInfoSubscribeRequest is required!')
    }
    // noinspection RedundantIfStatementJS
    if (!super.eq(other)) {
      return false
    }
    return true
  }

  /**
   * Convert struct to JSON
   * @this {!SymbolDayProfitLossMultipleInfoSubscribeRequest}
   * @returns {!object} Struct value for JSON
   */
  toJSON () {
    let parent = super.toJSON()
    let current = {
      Symbols: ((this.Symbols != null) ? Array.from(this.Symbols, item => ((item != null) ? item : null)) : null)
    }
    return { ...parent, ...current }
  }

  /**
   * Convert JSON to struct
   * @param {!string} json JSON string
   * @returns {!object} Struct value for JSON
   */
  static fromJSON (json) {
    return SymbolDayProfitLossMultipleInfoSubscribeRequest.fromObject(JSON.parse(json))
  }

  /**
   * Create struct from object value
   * @param {!SymbolDayProfitLossMultipleInfoSubscribeRequest} other Object value
   * @returns {!SymbolDayProfitLossMultipleInfoSubscribeRequest} Created struct
   */
  static fromObject (other) {
    return new SymbolDayProfitLossMultipleInfoSubscribeRequest().copy(other)
  }

  /**
   * Get the FBE type
   * @this {!SymbolDayProfitLossMultipleInfoSubscribeRequest}
   * @returns {!number} FBE type
   */
  get fbeType () {
    return SymbolDayProfitLossMultipleInfoSubscribeRequest.fbeType
  }

  /**
   * Get the FBE type (static)
   * @this {!SymbolDayProfitLossMultipleInfoSubscribeRequest}
   * @returns {!number} FBE type
   */
  static get fbeType () {
    return 5201
  }
}

export { SymbolDayProfitLossMultipleInfoSubscribeRequest };

/**
 * Fast Binary Encoding SymbolDayProfitLossMultipleInfoSubscribeRequest field model
 */
class FieldModelSymbolDayProfitLossMultipleInfoSubscribeRequest extends fbe.FieldModel {
  /**
   * Initialize field model with the given buffer and offset
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Buffer
   * @param {!number} offset Offset
   * @constructor
   */
  constructor (buffer, offset) {
    super(buffer, offset)
    this._parent = new FieldModelRequest(buffer, 4 + 4)
    this.Symbols = new fbe.FieldModelSet(new fbe.FieldModelString(buffer, this._parent.fbeOffset + this._parent.fbeBody - 4 - 4), buffer, this._parent.fbeOffset + this._parent.fbeBody - 4 - 4)
  }

  /**
   * Get the core.Request field model
   * @this {!FieldModelSymbolDayProfitLossMultipleInfoSubscribeRequest}
   * @returns {!FieldModelRequest} core.Request field model
   */
  get parent () {
    return this._parent
  }

  /**
   * Get the field size
   * @this {!FieldModelSymbolDayProfitLossMultipleInfoSubscribeRequest}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the field body size
   * @this {!FieldModelSymbolDayProfitLossMultipleInfoSubscribeRequest}
   * @returns {!number} Field body size
   */
  get fbeBody () {
    return 4 + 4 + this.parent.fbeBody - 4 - 4 + this.Symbols.fbeSize
  }

  /**
   * Get the field extra size
   * @this {!FieldModelSymbolDayProfitLossMultipleInfoSubscribeRequest}
   * @returns {!number} Field extra size
   */
  get fbeExtra () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4) > this._buffer.size)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)

    let fbeResult = this.fbeBody + this.parent.fbeExtra + this.Symbols.fbeExtra

    this._buffer.unshift(fbeStructOffset)

    return fbeResult
  }

  /**
   * Get the field type
   * @this {!FieldModelSymbolDayProfitLossMultipleInfoSubscribeRequest}
   * @returns {!number} Field type
   */
  get fbeType () {
    return FieldModelSymbolDayProfitLossMultipleInfoSubscribeRequest.fbeType
  }

  /**
   * Get the field type (static)
   * @this {!FieldModelSymbolDayProfitLossMultipleInfoSubscribeRequest}
   * @returns {!number} Field type
   */
  static get fbeType () {
    return 5201
  }

  /**
   * Check if the struct value is valid
   * @this {!FieldModelSymbolDayProfitLossMultipleInfoSubscribeRequest}
   * @param {!boolean} fbeVerifyType Verify model type flag, defaults is true
   * @returns {!boolean} Field model valid state
   */
  verify (fbeVerifyType = true) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return true
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return false
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    if (fbeStructSize < (4 + 4)) {
      return false
    }

    let fbeStructType = this.readUInt32(fbeStructOffset + 4)
    if (fbeVerifyType && (fbeStructType !== this.fbeType)) {
      return false
    }

    this._buffer.shift(fbeStructOffset)
    let fbeResult = this.verifyFields(fbeStructSize)
    this._buffer.unshift(fbeStructOffset)
    return fbeResult
  }

  /**
   * Check if the struct fields are valid
   * @this {!FieldModelSymbolDayProfitLossMultipleInfoSubscribeRequest}
   * @param {!number} fbeStructSize FBE struct size
   * @returns {!boolean} Field model valid state
   */
  verifyFields (fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) > fbeStructSize) {
      return true
    }
    if (!this.parent.verifyFields(fbeStructSize)) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.Symbols.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.Symbols.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Symbols.fbeSize

    return true
  }

  /**
   * Get the struct value (begin phase)
   * @this {!FieldModelSymbolDayProfitLossMultipleInfoSubscribeRequest}
   * @returns {!number} Field model begin offset
   */
  getBegin () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + 4 + 4) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return 0
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    console.assert((fbeStructSize >= (4 + 4)), 'Model is broken!')
    if (fbeStructSize < (4 + 4)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Get the struct value (end phase)
   * @this {!FieldModelSymbolDayProfitLossMultipleInfoSubscribeRequest}
   * @param {!number} fbeBegin Field model begin offset
   */
  getEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Get the struct value
   * @this {!FieldModelSymbolDayProfitLossMultipleInfoSubscribeRequest}
   * @param {!SymbolDayProfitLossMultipleInfoSubscribeRequest} fbeValue Default value, defaults is new SymbolDayProfitLossMultipleInfoSubscribeRequest()
   * @returns {!SymbolDayProfitLossMultipleInfoSubscribeRequest} SymbolDayProfitLossMultipleInfoSubscribeRequest value
   */
  get (fbeValue = new SymbolDayProfitLossMultipleInfoSubscribeRequest()) {
    let fbeBegin = this.getBegin()
    if (fbeBegin === 0) {
      return fbeValue
    }

    let fbeStructSize = this.readUInt32(0)
    this.getFields(fbeValue, fbeStructSize)
    this.getEnd(fbeBegin)
    return fbeValue
  }

  /**
   * Get the struct fields values
   * @this {!FieldModelSymbolDayProfitLossMultipleInfoSubscribeRequest}
   * @param {!SymbolDayProfitLossMultipleInfoSubscribeRequest} fbeValue SymbolDayProfitLossMultipleInfoSubscribeRequest value
   * @param {!number} fbeStructSize Struct size
   */
  getFields (fbeValue, fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) <= fbeStructSize) {
      this.parent.getFields(fbeValue, fbeStructSize)
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.Symbols.fbeSize) <= fbeStructSize) {
      this.Symbols.get(fbeValue.Symbols)
    } else {
      fbeValue.Symbols.clear()
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Symbols.fbeSize
  }

  /**
   * Set the struct value (begin phase)
   * @this {!FieldModelSymbolDayProfitLossMultipleInfoSubscribeRequest}
   * @returns {!number} Field model begin offset
   */
  setBegin () {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructSize = this.fbeBody
    let fbeStructOffset = this._buffer.allocate(fbeStructSize) - this._buffer.offset
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + fbeStructSize) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset <= 0) || ((this._buffer.offset + fbeStructOffset + fbeStructSize) > this._buffer.size)) {
      return 0
    }

    this.writeUInt32(this.fbeOffset, fbeStructOffset)
    this.writeUInt32(fbeStructOffset, fbeStructSize)
    this.writeUInt32(fbeStructOffset + 4, this.fbeType)

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Set the struct value (end phase)
   * @this {!FieldModelSymbolDayProfitLossMultipleInfoSubscribeRequest}
   * @param {!number} fbeBegin Field model begin offset
   */
  setEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Set the struct value
   * @this {!FieldModelSymbolDayProfitLossMultipleInfoSubscribeRequest}
   * @param {!SymbolDayProfitLossMultipleInfoSubscribeRequest} fbeValue SymbolDayProfitLossMultipleInfoSubscribeRequest value
   */
  set (fbeValue) {
    let fbeBegin = this.setBegin()
    if (fbeBegin === 0) {
      return
    }

    this.setFields(fbeValue)
    this.setEnd(fbeBegin)
  }

  /**
   * Set the struct fields values
   * @this {!FieldModelSymbolDayProfitLossMultipleInfoSubscribeRequest}
   * @param {SymbolDayProfitLossMultipleInfoSubscribeRequest} fbeValue SymbolDayProfitLossMultipleInfoSubscribeRequest value
   */
  setFields (fbeValue) {
    this.parent.setFields(fbeValue)
    this.Symbols.set(fbeValue.Symbols)
  }
}

export { FieldModelSymbolDayProfitLossMultipleInfoSubscribeRequest };

/**
 * Fast Binary Encoding SymbolDayProfitLossMultipleInfoSubscribeRequest model
 */
class SymbolDayProfitLossMultipleInfoSubscribeRequestModel extends fbe.Model {
  /**
   * Initialize model with the given buffer
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Read/Write buffer, defaults is new fbe.WriteBuffer()
   * @constructor
   */
  constructor (buffer = new fbe.WriteBuffer()) {
    super(buffer)
    this._model = new FieldModelSymbolDayProfitLossMultipleInfoSubscribeRequest(this.buffer, 4)
  }

  /**
   * Get the SymbolDayProfitLossMultipleInfoSubscribeRequest model
   * @this {!SymbolDayProfitLossMultipleInfoSubscribeRequestModel}
   * @returns {!FieldModelSymbolDayProfitLossMultipleInfoSubscribeRequest} model SymbolDayProfitLossMultipleInfoSubscribeRequest model
   */
  get model () {
    return this._model
  }

  /**
   * Get the model size
   * @this {!SymbolDayProfitLossMultipleInfoSubscribeRequestModel}
   * @returns {!number} Model size
   */
  get fbeSize () {
    return this.model.fbeSize + this.model.fbeExtra
  }

  /**
   * Get the model type
   * @this {!SymbolDayProfitLossMultipleInfoSubscribeRequestModel}
   * @returns {!number} Model type
   */
  get fbeType () {
    return SymbolDayProfitLossMultipleInfoSubscribeRequestModel.fbeType
  }

  /**
   * Get the model type (static)
   * @this {!SymbolDayProfitLossMultipleInfoSubscribeRequestModel}
   * @returns {!number} Model type
   */
  static get fbeType () {
    return FieldModelSymbolDayProfitLossMultipleInfoSubscribeRequest.fbeType
  }

  /**
   * Check if the struct value is valid
   * @this {!SymbolDayProfitLossMultipleInfoSubscribeRequestModel}
   * @returns {!boolean} Model valid state
   */
  verify () {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return false
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    if (fbeFullSize < this.model.fbeSize) {
      return false
    }

    return this.model.verify()
  }

  /**
   * Create a new model (begin phase)
   * @this {!SymbolDayProfitLossMultipleInfoSubscribeRequestModel}
   * @returns {!number} Model begin offset
   */
  createBegin () {
    return this.buffer.allocate(4 + this.model.fbeSize)
  }

  /**
   * Create a new model (end phase)
   * @this {!SymbolDayProfitLossMultipleInfoSubscribeRequestModel}
   * @param {!number} fbeBegin Model begin offset
   */
  createEnd (fbeBegin) {
    let fbeEnd = this.buffer.size
    let fbeFullSize = fbeEnd - fbeBegin
    this.writeUInt32(this.model.fbeOffset - 4, fbeFullSize)
    return fbeFullSize
  }

  /**
   * Serialize the struct value
   * @this {!SymbolDayProfitLossMultipleInfoSubscribeRequestModel}
   * @param {!SymbolDayProfitLossMultipleInfoSubscribeRequest} value SymbolDayProfitLossMultipleInfoSubscribeRequest value
   * @return {!number} Model begin offset
   */
  serialize (value) {
    let fbeBegin = this.createBegin()
    this.model.set(value)
    return this.createEnd(fbeBegin)
  }

  /**
   * Deserialize the struct value
   * @this {!SymbolDayProfitLossMultipleInfoSubscribeRequestModel}
   * @param {!SymbolDayProfitLossMultipleInfoSubscribeRequest} value SymbolDayProfitLossMultipleInfoSubscribeRequest value, defaults is new SymbolDayProfitLossMultipleInfoSubscribeRequest()
   * @return {!object} Deserialized SymbolDayProfitLossMultipleInfoSubscribeRequest value and its size
   */
  deserialize (value = new SymbolDayProfitLossMultipleInfoSubscribeRequest()) {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return { value: new SymbolDayProfitLossMultipleInfoSubscribeRequest(), size: 0 }
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    console.assert((fbeFullSize >= this.model.fbeSize), 'Model is broken!')
    if (fbeFullSize < this.model.fbeSize) {
      return { value: new SymbolDayProfitLossMultipleInfoSubscribeRequest(), size: 0 }
    }

    this.model.get(value)
    return { value: value, size: fbeFullSize }
  }

  /**
   * Move to the next struct value
   * @this {!SymbolDayProfitLossMultipleInfoSubscribeRequestModel}
   * @param {!number} prev Previous SymbolDayProfitLossMultipleInfoSubscribeRequest model size
   */
  next (prev) {
    this.model.fbeShift(prev)
  }
}

export { SymbolDayProfitLossMultipleInfoSubscribeRequestModel };
SymbolDayProfitLossMultipleInfoSubscribeRequest.__has_response = true;
SymbolDayProfitLossMultipleInfoSubscribeRequest.__response_class = SymbolDayProfitLossMultipleInfoSubscribeResponse;
